
import { Component, Emit, Prop, Vue } from 'bits/vue'
import BaseIcon from 'vuecomponents/base_icon.vue'

@Component({
  components: {
    BaseIcon,
  },
})
export default class CheckBox extends Vue {
  @Prop({ type: Boolean }) value!: boolean
  @Prop({ default: false }) disabled!: boolean
  @Prop({ required: false }) id!: string

  get iconClass() {
    return {
      'check-box-base-icon': true,
      'caption-type': !this.value,
      'highlighted-type': this.value,
    }
  }

  get iconText() {
    if (this.value) {
      return 'check_box'
    }
    return 'check_box_outline_blank'
  }

  @Emit('input')
  change(e) {
    return e.target.checked
  }
}
